import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function WhatsAppButton() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const [tooltipDismissed, setTooltipDismissed] = useState(false)
  const [overRed, setOverRed] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400)
      const section = document.getElementById('quote-section')
      if (section) {
        const { top, bottom } = section.getBoundingClientRect()
        const buttonY = window.innerHeight - 52 // approx center of fixed button
        setOverRed(top <= buttonY && buttonY <= bottom)
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Show tooltip automatically 2s after button appears
  useEffect(() => {
    if (!visible || tooltipDismissed) return
    const timer = setTimeout(() => setTooltipOpen(true), 2000)
    return () => clearTimeout(timer)
  }, [visible, tooltipDismissed])

  const whatsappUrl = `https://wa.me/376681104?text=${encodeURIComponent(t('whatsapp.prefill'))}`

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
    >
      {/* Tooltip bubble */}
      {visible && tooltipOpen && (
        <div className="relative bg-white rounded-2xl shadow-lg p-4 pr-8 max-w-[240px] animate-fade-in">
          <button
            onClick={() => {
              setTooltipOpen(false)
              setTooltipDismissed(true)
            }}
            className="absolute top-2 right-2 text-espresso/40 hover:text-espresso text-sm leading-none cursor-pointer"
            aria-label="Schließen"
          >
            ✕
          </button>
          <p className="font-body text-espresso/70 text-xs leading-relaxed mb-3">
            <span className="font-semibold text-rot">{t('whatsapp.greeting')}</span>{' '}
            {t('whatsapp.text')}
          </p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-rot text-sand text-xs font-body rounded-full px-4 py-2 hover:bg-lachs transition-colors"
          >
            {t('whatsapp.send')}
          </a>
          {/* Triangle pointer */}
          <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white rotate-45 shadow-sm" />
        </div>
      )}

      {/* Floating button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Chat"
        className={`group flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-colors duration-300 ${overRed ? 'bg-sand hover:bg-haut' : 'bg-rot hover:bg-lachs'}`}
      >
        {/* Chat icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.5}
          className={`w-6 h-6 ${overRed ? 'text-rot' : 'text-sand'}`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M7.5 8.25h9m-9 3H12m-9.75 1.5c0 4.97 4.03 9 9 9a8.96 8.96 0 004.795-1.38l4.705 1.13-1.13-4.705A8.96 8.96 0 0021.75 12.75c0-4.97-4.03-9-9-9s-9 4.03-9 9z"
          />
        </svg>
      </a>
    </div>
  )
}
